module.exports = __webpack_public_path__ + "img/wikipedia.b8a0a731.jpg";